import { ui } from "components/util/uiHelpers";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";



type TwoColumnContainerProps = {
    children?: React.ReactNode;
    disablePadding?: boolean;
    style?: React.CSSProperties;
};

export const HouseholdInsuranceTwoColumnContainer = ({ children, disablePadding, style, }: TwoColumnContainerProps) => {
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    return (
        <div
            style={{
                alignItems: isMobile ? "flex-start" : "center",
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: 8,
                padding: disablePadding ? 0 : "40px 25px",
                ...style
            }}
        >
            {children}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/householdInsurance/components/HouseholdInsuranceTwoColumnContainer.tsx